import { useState, useLayoutEffect } from "react";
import { updatePalette, hexToRGBCode, darkenRGB, lightenRGB } from "@wf/components";
import type { HEX } from "@wf/components";

const WF_PRIMARY_COLOR_NAME = "--wf-colors-primary";

const useColors = ({ primaryColorHex }: { primaryColorHex: string }) => {
  const [colorsApplied, setColorsApplied] = useState(false);

  useLayoutEffect(() => {
    if (primaryColorHex) {
      const rgbCode = hexToRGBCode(primaryColorHex as HEX);
      if (rgbCode.length) {
        const { style } = document.documentElement;
        updatePalette();
        style.setProperty(WF_PRIMARY_COLOR_NAME, `rgb(${rgbCode.toString()})`);
        style.setProperty(`${WF_PRIMARY_COLOR_NAME}-lighten-30`, `rgb(${lightenRGB(rgbCode, 30).toString()})`);
        style.setProperty(`${WF_PRIMARY_COLOR_NAME}-lighten-50`, `rgb(${lightenRGB(rgbCode, 50).toString()})`);
        style.setProperty(`${WF_PRIMARY_COLOR_NAME}-lighten-80`, `rgb(${lightenRGB(rgbCode, 80).toString()})`);
        style.setProperty(`${WF_PRIMARY_COLOR_NAME}-lighten-90`, `rgb(${lightenRGB(rgbCode, 90).toString()})`);
        style.setProperty(`${WF_PRIMARY_COLOR_NAME}-darken-10`, `rgb(${darkenRGB(rgbCode, 15).toString()})`);
      }
      setColorsApplied(true);
    }
  }, [primaryColorHex]);

  return colorsApplied;
};

export default useColors;
